import React from "react";
import { Heading, ListItem, List, Text } from "spectacle";
import Button from '../components/Button';

const PersonalizationBootcamp = () =>
    <div>
        <Heading size={6} textColor="fifth" caps>
            Sitecore xConnect Boot camp
        </Heading>
        <Text textSize={30} textColor="primary">
            Identify what customer data should be leveraged to fully optimize the customer experience across channels
        </Text>
        <List ordered textColor="primary" style={{paddingLeft: '25px', listStylePosition: 'outside'}}>
            <ListItem textSize={25}>Fully leverage any and all data points about your customers, whether collected on the web or integrated from a customer database, to bring a more personal experience to your customers</ListItem>
            <ListItem textSize={25}>Understand how to integrate a unified view of your customer to any channel</ListItem>
            <ListItem textSize={25}>Leverage customer data in real time to advance the connect the customer experience</ListItem>
        </List>
        <Button targetUrl='https://altola.co/bootcamps/xconnect' />
    </div>

export default PersonalizationBootcamp;


// WEBPACK FOOTER //
// ./src/slides/xConnectBootcamp.js